import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=29a4cd43&scoped=true&"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js&"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=29a4cd43&lang=less&"
import style1 from "./AvatarDropdown.vue?vue&type=style&index=1&id=29a4cd43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4cd43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a4cd43')) {
      api.createRecord('29a4cd43', component.options)
    } else {
      api.reload('29a4cd43', component.options)
    }
    module.hot.accept("./AvatarDropdown.vue?vue&type=template&id=29a4cd43&scoped=true&", function () {
      api.rerender('29a4cd43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GuideLayout/AvatarDropdown.vue"
export default component.exports